import { useEffect, useState } from "react";
import { Download } from "lucide-react";

const links = [
    { label: "Demo", href: "#hero" },
    { label: "How it works", href: "#how" },
    { label: "Captains", href: "#captains" },
    { label: "FAQ", href: "#faq" },
];

export const scrollToSection = (e, href) => {
    if (e) e.preventDefault();
    const el = document.querySelector(href);
    if (!el) {
        window.location.href = "/" + href;
        return;
    }
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
                scrolled ? "border-b border-line bg-paper md:bg-paper/80 md:backdrop-blur-xl" : "bg-transparent"
            }`}
        >
            <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
                <a
                    href="#hero"
                    onClick={(e) => scrollToSection(e, "#hero")}
                    data-testid="nav-logo"
                    className="flex items-center gap-2.5"
                >
                    <img
                        src="/app-logo.png"
                        alt="RapidClick logo"
                        className="h-9 w-9 object-contain"
                    />
                    <span className="font-display text-lg font-bold tracking-tight">RapidClick</span>
                </a>
                <div className="hidden items-center gap-8 md:flex">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={(e) => scrollToSection(e, l.href)}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="font-mono text-[11px] uppercase tracking-[0.18em] text-mute transition-colors hover:text-ink"
                        >
                            {l.label}
                        </a>
                    ))}
                </div>
                <a
                    href="#download"
                    onClick={(e) => scrollToSection(e, "#download")}
                    data-testid="nav-download-btn"
                    className="inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 text-xs font-bold text-white transition-transform duration-300 hover:scale-105"
                >
                    <Download size={13} /> Get the app
                </a>
            </nav>
        </header>
    );
}
